if (!customElements.get('product-tabs')) {
  class ProductTabs extends HTMLElement {
    connectedCallback() {
      this.titles   = [...this.querySelectorAll('.list-title')];
      this.contents = [...this.querySelectorAll('.product-tab-content')];

      this.titles.forEach(title => {
        title.addEventListener('click', () => this.onTabClick(title));
      });

      // Notify read-more in the initially active panel after layout is ready
      window.addEventListener('load',   () => this.notifyAll());
      window.addEventListener('resize', () => this.notifyAll());
    }

    onTabClick(title) {
      const tabHandle = title.getAttribute('data-tab');

      this.titles.forEach(t => {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      this.contents.forEach(c => c.classList.remove('is-active'));

      title.classList.add('is-active');
      title.setAttribute('aria-selected', 'true');

      // Match panel via data-tab-panel attribute — no section.id needed
      const targetPanel = this.querySelector(`[data-tab-panel="${tabHandle}"]`);
      if (targetPanel) {
        targetPanel.classList.add('is-active');
        // Delay slightly so display:block has taken effect before measuring
        setTimeout(() => this.notifyReadMore(targetPanel), 10);
      }
    }

    notifyReadMore(panel) {
      panel.querySelectorAll('read-more').forEach(el => {
        if (typeof el.checkOverflow === 'function') el.checkOverflow();
      });
    }

    notifyAll() {
      const active = this.querySelector('.product-tab-content.is-active');
      if (active) this.notifyReadMore(active);
    }
  }

  customElements.define('product-tabs', ProductTabs);
}
